<div class="overflow-hidden rounded-2xl border border-gray-200 bg-white px-5 pb-3 pt-4 dark:border-white/[0.05] dark:bg-white/[0.03] sm:px-6">
  <div class="flex justify-between gap-2 mb-4 sm:items-center">
    <div>
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
        Featured Campaigns
      </h3>
    </div>

    <div class="relative inline-block">
      <app-table-dropdown>
        <div dropdown-button>
          <button class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
            <svg class="size-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.99902 10.245C6.96552 10.245 7.74902 11.0285 7.74902 11.995V12.005C7.74902 12.9715 6.96552 13.755 5.99902 13.755C5.03253 13.755 4.24902 12.9715 4.24902 12.005V11.995C4.24902 11.0285 5.03253 10.245 5.99902 10.245ZM17.999 10.245C18.9655 10.245 19.749 11.0285 19.749 11.995V12.005C19.749 12.9715 18.9655 13.755 17.999 13.755C17.0325 13.755 16.249 12.9715 16.249 12.005V11.995C16.249 11.0285 17.0325 10.245 17.999 10.245ZM13.749 11.995C13.749 11.0285 12.9655 10.245 11.999 10.245C11.0325 10.245 10.249 11.0285 10.249 11.995V12.005C10.249 12.9715 11.0325 13.755 11.999 13.755C12.9655 13.755 13.749 12.9715 13.749 12.005V11.995Z"
              />
            </svg>
          </button>
        </div>
        <div dropdown-content>
          <button
            (click)="handleViewMore()"
            class="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300 p-2"
          >
            View More
          </button>
          <button
            (click)="handleDelete()"
            class="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300 p-2"
          >
            Delete
          </button>
        </div>
      </app-table-dropdown>
    </div>
  </div>

  <div class="max-w-full overflow-x-auto">
    <table class="w-full">
      <thead class="border-gray-100 border-y dark:border-white/[0.05]">
        <tr>
          <th scope="col" class="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">
            Products
          </th>
          <th scope="col" class="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">
            Campaign
          </th>
          <th scope="col" class="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">
            Status
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
        @for (item of campaigns; track $index) {
        <tr>
          <td class="py-3">
            <div class="flex items-center gap-[18px]">
              <div class="w-10 h-10 overflow-hidden rounded-full">
                <img
                  width="40"
                  height="40"
                  class="w-full size-10"
                  [src]="item.creator.image"
                  alt="user"
                />
              </div>
              <div>
                <p class="text-gray-700 text-theme-sm dark:text-gray-400">
                  {{item.creator.name}}
                </p>
              </div>
            </div>
          </td>
          <td class="py-3">
            <div class="flex items-center w-full gap-5">
              <div class="w-full max-w-8">
                <img
                  width="32"
                  height="32"
                  class="w-full size-8"
                  [src]="item.campaign.image"
                  alt="brand"
                />
              </div>
              <div class="truncate">
                <p class="mb-0.5 truncate text-theme-sm font-medium text-gray-700 dark:text-gray-400">
                  {{item.campaign.name}}
                </p>
                <span class="text-gray-500 text-theme-xs dark:text-gray-400">
                  {{item.campaign.type}}
                </span>
              </div>
            </div>
          </td>
          <td class="py-3">
            <app-badge
              size="sm"
              [color]="item.status === 'Success' ? 'success' : item.status === 'Pending' ? 'warning' : 'error'"
            >
              {{item.status}}
            </app-badge>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>